<template>
    <div class="product_list">
        <!-- 头部 -->
        <div class="list_header">
            <div class="back_btn" @click="goBack">
                <i class="iconfont icon-fanhui"></i>
            </div>
            <span class="header_title">产品</span>
            <div class="placeholder"></div>
        </div>

        <!-- 搜索栏 -->
        <div class="search_section">
            <div class="search_row">
                <div class="search_box">
                    <van-icon name="search" size="18" color="#999" />
                    <input type="text" v-model="searchName" placeholder="产品名称" @input="onSearch">
                </div>
                <div class="search_box">
                    <van-icon name="search" size="18" color="#999" />
                    <input type="text" v-model="searchCode" placeholder="产品型号" @input="onSearch">
                </div>
            </div>
        </div>

        <!-- 统计 -->
        <div class="stat_bar">
            <div class="stat_item">
                <span class="stat_value">{{stat.total}}</span>
                <span class="stat_text">总记录</span>
            </div>
        </div>

        <!-- 列表 -->
        <div class="list_content">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="加载中..."
                    @load="onLoad"
                >
                    <div class="product_cards" v-if="list.length > 0">
                        <div class="product_card" v-for="item in list" :key="item.id" :class="{recently_viewed: isRecentlyViewed(item.id)}">
                            <div class="rv_badge" v-if="isRecentlyViewed(item.id)">
                                <van-icon name="eye-o" size="12" />
                                <span>刚看过</span>
                            </div>
                            <!-- 产品主信息 -->
                            <div class="card_main" @click="toDetail(item)">
                                <div class="card_img">
                                    <img :src="item.imgs | getFirstImg" alt="" @error="handleImgError($event)">
                                    <div class="img_placeholder" v-if="!item.imgs"></div>
                                </div>
                                <div class="card_info">
                                    <div class="info_name">{{item.name}}</div>
                                    <div class="info_code">型号: {{item.code}}</div>
                                    <div class="info_stock">
                                        <span class="stock_label">库存总量:</span>
                                        <span class="stock_num" :class="{low: item.stock_num < 10}">{{item.stock_num}}</span>
                                    </div>
                                    <div class="warehouse_info" v-if="item.stock_num_info && item.stock_num_info.length">
                                        <span class="wh_tag" v-for="(wh, idx) in item.stock_num_info" :key="idx">
                                            {{wh.stock_name}} <b :style="{color: wh.StockNum > 0 ? '#4E89FF' : '#ccc'}">{{wh.StockNum}}</b>
                                        </span>
                                    </div>
                                </div>
                                <div class="card_arrow">
                                    <i class="iconfont icon-gengduo1"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 空状态 -->
                    <div class="empty_state" v-else-if="!loading && list.length === 0">
                        <img src="/static/imgs/no_data.jpg" alt="">
                        <span>暂无数据</span>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>

        <!-- 发货按钮 -->
        <van-button class="ship_btn" icon="logistics" type="danger" @click="openShipment" />

        <!-- 发货弹窗 -->
        <shipment-dialog
            v-model="showShipmentDialog"
            shipment-type="product"
            :preselected-items="preselectedShipmentItems"
            :user-info="userInfo"
            @success="onShipmentSuccess"
        />
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import ShipmentDialog from '@/components/ShipmentDialog.vue'

export default {
    name: 'ProductList',
    components: {
        ShipmentDialog
    },
    data() {
        return {
            searchName: '',
            searchCode: '',
            list: [],
            page: 1,
            each_page: 10,
            loading: false,
            finished: false,
            refreshing: false,
            isFetching: false,
            stat: {
                total: 0,
                low_stock: 0
            },
            userInfo: {},
            showShipmentDialog: false,
            preselectedShipmentItems: []
        }
    },
    filters: {
        getFirstImg(imgs) {
            if (!imgs) return '/static/imgs/no_img.png'
            // 支持多张图片用逗号分隔
            if (imgs.includes(',')) {
                return imgs.split(',')[0]
            }
            return imgs
        }
    },
    mounted() {
        document.title = "产品管理"
        this.init()
    },
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back()
            } else {
                this.$router.replace('/mine')
            }
        },
        async init() {
            await this.getUserInfo()
            this.getList()
        },
        async getUserInfo() {
            try {
                let data = await studio_api.Teaching_studio_apiMemberLogin_userGet({ app_id: this.$root.app_id })
                if (data.errcode == 0) {
                    this.userInfo = data.other
                }
            } catch(e) {}
        },
        // 图片加载失败处理
        handleImgError(e) {
            // 隐藏图片，显示占位背景
            e.target.style.display = 'none'
            e.target.parentElement.classList.add('img_error')
        },
        // 搜索
        onSearch() {
            this.page = 1
            this.finished = false
            this.getList()
        },

        // 刷新
        onRefresh() {
            this.page = 1
            this.list = []
            this.finished = false
            this.loading = true
            this.getList()
        },

        // 加载更多
        onLoad() {
            if (this.finished || this.isFetching) {
                this.loading = false
                return
            }
            this.getList()
        },

        // 获取列表
        async getList() {
            if (this.isFetching) return
            this.isFetching = true
            this.loading = true
            
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxProductListGet({
                    app_id: this.$root.app_id,
                    name: this.searchName,
                    code: this.searchCode,
                    page: this.page,
                    each_page: this.each_page
                })
                
                if (res.errcode == 0) {
                    // 接口返回格式: {count: 3, list: [...]}
                    let list = res.other && res.other.list ? res.other.list : []
                    
                    // 产品列表
                    if (this.page === 1) {
                        this.list = list
                    } else {
                        let newItems = list.filter(item => !this.list.some(existing => existing.id === item.id))
                        this.list = this.list.concat(newItems)
                    }
                    // 有库存靠前，无库存靠后
                    this.list.sort((a, b) => ((b.stock_num || 0) > 0 ? 1 : 0) - ((a.stock_num || 0) > 0 ? 1 : 0))
                    
                    // 统计
                    this.stat.total = res.other && res.other.count ? res.other.count : this.list.length
                    
                    if (list.length < this.each_page) {
                        this.finished = true
                    } else {
                        this.page++
                    }
                } else {
                    this.finished = true
                }
            } catch (e) {
                console.log('获取列表失败', e)
                this.finished = true
            } finally {
                this.$nextTick(() => {
                    this.isFetching = false
                    this.loading = false
                    this.refreshing = false
                })
            }
        },

        // 查看产品详情
        toDetail(item) {
            sessionStorage.setItem('last_viewed_product', item.id)
            this.$router.push({
                path: '/warehouse/detail',
                query: { type: 'product', id: item.id }
            })
        },

        isRecentlyViewed(id) {
            return sessionStorage.getItem('last_viewed_product') == id
        },

        // 打开发货弹窗
        openShipment(item) {
            if (item) {
                this.preselectedShipmentItems = [{
                    id: item.id,
                    name: item.name,
                    code: item.code,
                    stock_num: item.stock_num || 0
                }]
            } else {
                this.preselectedShipmentItems = []
            }
            this.showShipmentDialog = true
        },

        onShipmentSuccess() {
            this.page = 1
            this.list = []
            this.finished = false
            this.getList()
        }
    }
}
</script>

<style scoped>
.product_list {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    background: #F6F6F6;
}

.list_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.back_btn i {
    font-size: 40px;
    color: #333;
}

.header_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.placeholder {
    width: 40px;
}

.search_section {
    padding: 20px 30px;
    background: #fff;
}

.search_row {
    display: flex;
    gap: 16px;
}

.search_box {
    flex: 1;
    height: 64px;
    background: #F6F6F6;
    border-radius: 32px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
}

.search_box .van-icon {
    flex-shrink: 0;
}

.search_box input {
    flex: 1;
    margin-left: 12px;
    border: none;
    background: transparent;
    font-size: 26px;
    outline: none;
    width: 100%;
}

.stat_bar {
    display: flex;
    padding: 0 30px 20px;
    background: #fff;
    gap: 40px;
}

.stat_item {
    display: flex;
    align-items: center;
    gap: 12px;
}

.stat_value {
    font-size: 36px;
    font-weight: bold;
    color: #4E89FF;
}

.stat_value.warning {
    color: #F44336;
}

.stat_text {
    font-size: 26px;
    color: #999;
}

.list_content {
    padding: 20px 30px;
}

.product_cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.product_card {
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    display: flex;
    flex-direction: column;
}

.card_main {
    display: flex;
    align-items: center;
}

.card_img {
    width: 120px;
    height: 120px;
    border-radius: 12px;
    overflow: hidden;
    background: #f5f5f5;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card_img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card_img.img_error {
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
}

.card_img.img_error::before {
    content: '无图片';
    color: #999;
    font-size: 24px;
}

.card_info {
    flex: 1;
    margin-left: 24px;
}

.info_name {
    font-size: 30px;
    color: #333;
    font-weight: bold;
    line-height: 1.4;
}

.info_code {
    font-size: 24px;
    color: #999;
    margin-top: 8px;
}

.info_stock {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(78, 137, 255, 0.06);
    padding: 8px 16px;
    border-radius: 8px;
    width: fit-content;
}

.stock_label {
    font-size: 24px;
    color: #666;
}

.stock_num {
    font-size: 36px;
    font-weight: bold;
    color: #4E89FF;
}

.stock_num.low {
    color: #F44336;
}

.warehouse_info {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.wh_tag {
    font-size: 22px;
    color: #666;
    background: #f0f5ff;
    border: 1px solid rgba(78, 137, 255, 0.15);
    padding: 4px 14px;
    border-radius: 6px;
}

.wh_tag b {
    font-weight: bold;
    margin-left: 4px;
}

/* 关联物料 */
.card_arrow {
    margin-left: 16px;
}

.card_arrow i {
    font-size: 32px;
    color: #ccc;
}

.empty_state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px 0;
}

.empty_state img {
    width: 300px;
    height: 150px;
    object-fit: contain;
}

.empty_state span {
    font-size: 28px;
    color: #999;
    margin-top: 20px;
}

.recently_viewed {
    border-left: 8px solid #4E89FF;
    background: linear-gradient(135deg, rgba(78,137,255,0.08) 0%, rgba(78,137,255,0.02) 100%);
    box-shadow: 0 0 0 2px rgba(78,137,255,0.15), 0 4px 16px rgba(78,137,255,0.12);
    position: relative;
}

.rv_badge {
    position: absolute;
    top: -1px;
    right: 16px;
    background: linear-gradient(135deg, #4E89FF, #6C63FF);
    color: #fff;
    font-size: 20px;
    padding: 4px 14px 6px;
    border-radius: 0 0 10px 10px;
    display: flex;
    align-items: center;
    gap: 4px;
    z-index: 2;
    box-shadow: 0 2px 8px rgba(78,137,255,0.3);
    animation: rvPulse 2s ease-in-out infinite;
}

@keyframes rvPulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
}

.ship_btn {
    position: fixed;
    right: 24px;
    bottom: 60px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
    box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    border: none;
    transition: all 0.3s ease;
}

.ship_btn:active {
    transform: scale(0.9);
}
</style>
